import * as types from './types';
export default {
  setAbTestToggleState(_ref, state) {
    var {
      commit
    } = _ref;
    commit(types.SEND_ABTEST_TOGGLE, state);
  },
  setAbTestToggleTooltyState(_ref2, state) {
    var {
      commit
    } = _ref2;
    commit(types.SEND_ABTEST_TOOLTYPE_TOGGLE, state);
  }
};